import { mapGetters } from 'vuex'
import previewCarousel from '@/components/cms/preview-carousel/preview-carousel.vue';
import previewCarouselMobile
  from '@/components/cms/preview-carousel-mobile/preview-carousel-mobile.vue';

export default {
  components: {
    previewCarousel,
    previewCarouselMobile,
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-stories/page-stories.js